import { useEffect, useRef, useState, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { logout } from "../redux/slices/auth/authSlice";
import {
  setLastActivityTime,
  clearLastActivityTime,
} from "../utils/autoLogout";
import Alert from "../components/Modal/Alert"; // Update the import path
import { AUTH_CONFIG } from "../pages/Authentication/auth.config";

export const useAutoLogout = () => {
  const dispatch = useDispatch();
  const { isAuthenticated } = useSelector((state) => state.auth);
  const warningTimerRef = useRef(null);
  const logoutTimerRef = useRef(null);
  const [showWarning, setShowWarning] = useState(false);

  const handleLogout = useCallback(() => {
    clearLastActivityTime();
    dispatch(logout());
  }, [dispatch]);

  const handleWarningClose = useCallback(() => {
    setShowWarning(false);
  }, []);

  useEffect(() => {
    if (isAuthenticated) {
      setLastActivityTime();

      warningTimerRef.current = setTimeout(() => {
        setShowWarning(true);
      }, AUTH_CONFIG.SESSION.DURATION - AUTH_CONFIG.SESSION.WARNING_OFFSET);

      logoutTimerRef.current = setTimeout(() => {
        handleLogout();
      }, AUTH_CONFIG.SESSION.DURATION);

      return () => {
        if (warningTimerRef.current) clearTimeout(warningTimerRef.current);
        if (logoutTimerRef.current) clearTimeout(logoutTimerRef.current);
        setShowWarning(false);
      };
    }
  }, [isAuthenticated, handleLogout]);

  return { showWarning, handleWarningClose };
};
